import { simpleParallax } from '@hh/global.js'

class HHProductMediaWrapper extends HTMLElement {
  constructor() {
    super()
    this.images = this.querySelectorAll('[slot="item"] img')
    this.imageWrappers = this.querySelectorAll('.js-thumbnail-image')
    this.isMobile = window.matchMedia('(max-width: 750px)').matches
    this.imageParallax = null
    this.parallaxSettings = {
      scale: 1,
      customWrapper: '.js-thumbnail-image',
    }

    this.zoomCursor = this.querySelector('.js-zoom-cursor')
  }

  connectedCallback() {
    window.addEventListener('resize', this.onResize.bind(this))
    if (this.isMobile) return
    this.initParallaxImages()

    window.addEventListener('mousemove', this.onMouseMove.bind(this))
    this.imageWrappers.forEach((wrapper) => {
      wrapper.addEventListener('mouseleave', this.onMouseOut.bind(this))
      wrapper.addEventListener('mouseenter', this.onMouseEnter.bind(this))
    })
  }

  disconnectCallback() {
    this.imageParallax.destroy()
    window.removeEventListener('resize', this.onResize)
    window.removeEventListener('mousemove', this.onMouseMove)
  }

  initParallaxImages() {
    this.imageParallax = new simpleParallax(this.images, this.parallaxSettings)

    setTimeout(() => {
      this.imageParallax.refresh()
    }, 500)
  }

  onResize() {
    this.isMobile = window.matchMedia('(max-width: 750px)').matches

    if (this.isMobile && this.imageParallax) {
      this.imageParallax.destroy()
      return
    }

    this.imageParallax
      ? this.imageParallax.refresh()
      : this.initParallaxImages()
  }

  onMouseMove(e) {
    if (!this.zoomCursor) return

    const canZoom = e.target.closest('.js-zoomable')

    this.zoomCursor.style.display = canZoom ? 'block' : 'none'

    const mouseY = e.clientY
    const mouseX = e.clientX

    this.zoomCursor.style.transform = `translate3d(calc(${mouseX}px - 50%), calc(${mouseY}px - 50%), 0)`
  }

  onMouseOut() {
    this.zoomCursor.style.display = 'none'
  }

  onMouseEnter(e) {
    const canZoom = e.target.closest('.js-zoomable')
    if (!canZoom) return

    this.zoomCursor.style.display = 'block'
  }
}

customElements.define('hh-product-media-wrapper', HHProductMediaWrapper)
